const validate = (values) => {
    const errors = {};
  
    if (!values.libraryId) {
      errors.libraryId = 'Please Select Library'
    }
    if (!values.domainId) {
      errors.domainId = 'Please Select Domain'
    }
    if (!values.programId) {
      errors.programId = 'Please Select Program'
    }
    return errors;
  };
  export default validate;
  


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Program/validate.js